import { useRouter } from "@uirouter/react";
import { noop } from "lodash";
import { useCallback, useContext } from "react";
import { useAppLoader } from "../../../components/loader/app-loader-hook";
import { GlobalOverlayContext } from "../../../components/overlay/context";
import { Widget } from "../../../components/widget";
import { UsersDTO } from "../../../store/users/models/dto";
import { UsersService } from "../../../store/users/service";
import { UsersRoutes } from "../../users/routes";
import { NewMerchant } from "./inner-component";
import { PasswordGeneratedModal } from "./password-generated";

type CreateMerchant = UsersDTO.Requests.Merchant.Create.T;

export const NewMerchantPage = () => {
  const loader = useAppLoader();
  const router = useRouter();
  const { setOverlay } = useContext(GlobalOverlayContext);

  const onSubmit = useCallback(
    (x: CreateMerchant) =>
      loader(UsersService.createMerchant(x))
        .then((response) =>
          router.stateService
            .go(UsersRoutes.names.single, {
              id: response.credentialsId,
            })
            .finally(() => {
              setOverlay({
                title: "Merchant Password",
                children: <PasswordGeneratedModal {...response} />,
              });
            })
        )
        .catch(noop),
    [router]
  );

  return (
    <Widget>
      <NewMerchant onSubmit={onSubmit} />
    </Widget>
  );
};
